/* eslint-disable */
import {
  Layout,
  Row,
  Col,
  Card,
  Typography,
  Button,
  Space,
  Select,
  DatePicker,
  message,
  Tooltip,
  Drawer,
  Radio,
} from "antd";
import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import api from "@/utils/api";
import http from "@/utils/http";
import dayjs from "dayjs";
import { CustomTable } from "@/hocComponents";
import declineIcon from "@/assets/images/icons/decline.png";
import riseIcon from "@/assets/images/icons/rise.png";
import commonFn from "@/utils/commonFn";
import { InfoCircleOutlined , CaretDownOutlined, CaretUpOutlined,} from "@ant-design/icons";
import rentIcon from "@/assets/images/icons/rent.png";
import utilityIcon from "@/assets/images/icons/utility.png";
import otherIcon from "@/assets/images/icons/other.png";
import { formatDateText } from "@/utils/date";
import UnitDetailDrawer from "./UnitDetailDrawer";
import PropDetailDrawer from "./PropDetailDrawer";
import "./index.scss";
const formatVacancyRate = (value) => {
  if (value === undefined || value === null) return "0%";
  return `${(value * 100).toFixed(2)}%`;
};

const AreaIndex = forwardRef((props, ref) => {
  const [tableLoading, setTableLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerPropVisible, setDrawerPropVisible] = useState(false);
  const [drawerType, setDrawerType] = useState("");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const isFetching = useRef(false);
  const isInitialized = useRef(false);
  // 获取数据
  const fetchAreaData = async () => {
    if (isFetching.current) return;
    isFetching.current = true;
    setTableLoading(true);
    try {
      const res = await http.get(api.getSnapshotByArea);
      if (res?.code === "1" && res?.data) {
        const processedData = res.data.map((item) => {
          const newItem = { ...item };
          return newItem;
        });
        processTableData(processedData);
      } else {
        message.error(res?.msg);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      message.error("Failed to fetch data");
    } finally {
      setTableLoading(false);
      isFetching.current = false;
      isInitialized.current = true;
    }
  };
  useImperativeHandle(ref, () => ({
    refresh() {
      if (isInitialized.current) {
        fetchAreaData();
      }
    },
  }));
  // 打开Drawer的处理函数
  const handleOpenDrawer = (record, type) => {
    setSelectedRecord(record);
    setDrawerType(type);
    setDrawerVisible(true);
  };

  // 关闭Drawer
  const handleCloseDrawer = () => {
    setDrawerVisible(false);
    setSelectedRecord(null);
    setDrawerType("");
  };
  const handleOpenPropDrawer = (record, type) => {
    setSelectedRecord(record);
    setDrawerType(type);
    setDrawerPropVisible(true);
  };

  const handleClosePropDrawer = () => {
    setDrawerPropVisible(false);
    setSelectedRecord(null);
    setDrawerType("");
  };

  useEffect(() => {
    fetchAreaData();
  }, []);

  // 处理表格数据 - 动态生成列和数据
  const processTableData = (data) => {
    if (!data || data.length === 0) {
      setFilteredData([]);
      setColumns([]);
      return;
    }

    const allDateKeys = new Set();
    data.forEach((item) => {
      if (item.history) {
        Object.keys(item.history).forEach((dateKey) => {
          allDateKeys.add(dateKey);
        });
      }
    });

    const sortedDateKeys = Array.from(allDateKeys).sort((a, b) => {
      return dayjs(b).valueOf() - dayjs(a).valueOf();
    });

    const todayStr = dayjs().format("YYYY-MM-DD");
    const yesterdayStr = dayjs().subtract(1, "day").format("YYYY-MM-DD");
    const todayKeys = sortedDateKeys.filter((key) => key === todayStr);
    const yesterdayKeys = sortedDateKeys.filter((key) => key === yesterdayStr);
    const otherKeys = sortedDateKeys.filter(
      (key) => key !== todayStr && key !== yesterdayStr,
    );
    const orderedKeys = [...todayKeys, ...yesterdayKeys, ...otherKeys];
    const getDayOfWeek = (dateStr) => {
      return dayjs(dateStr).format("dddd");
    };
    const dynamicColumns = [
      {
        title: "Area",
        dataIndex: "area",
        key: "area",
        fixed: "center",
        width: 150,
        render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
      },
      {
        title: "Total Units",
        dataIndex: "totalUnits",
        key: "totalUnits",
        width: 120,
        align: "center",
        render: (text) => {
          if (text === "-" || text === undefined || text === null) return " ";
          return typeof text === "number" ? text?.toLocaleString() : text;
        },
        render: (text, record) => {
          if (text === "-" || text === undefined || text === null) return " ";
          const displayText =
            typeof text === "number" ? text?.toLocaleString() : text;
          return (
            <span
              style={{
                color: "#1890ff",
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleOpenPropDrawer(record, "area");
              }}
            >
              {displayText}
            </span>
          );
        },
      },
      {
        title: "Vacancy %",
        dataIndex: "vacancyRate",
        key: "vacancyRate",
        width: 120,
        align: "center",
        render: (text) => formatVacancyRate(text),
      },
    ];

    // 添加动态日期列
    orderedKeys.forEach((dateKey, index) => {
      const formattedDate = formatDateText(new Date(dateKey));
      const dayOfWeek = getDayOfWeek(dateKey);

      let label = formattedDate;
      if (dateKey === todayStr) {
        label = "Today";
      } else if (dateKey === yesterdayStr) {
        label = "Yesterday";
      } else {
        label = dayOfWeek;
      }

 dynamicColumns.push({
  title: () => (
    <div style={{ textAlign: "center", fontWeight: "bold" }}>
      <div>{formattedDate}</div>
      <div
        style={{ fontSize: "12px", fontWeight: "normal", color: "#888" }}
      >
        {label}
      </div>
    </div>
  ),
  dataIndex: dateKey,
  key: dateKey,
  width: 140,
  render: (text, record) => {
    if (text === "-" || text === undefined || text === null) return "-";

    // 判断是否为第一个渲染的日期（即 orderedKeys 的第一个）
    const isFirstDate = dateKey === orderedKeys[0];

    if (isFirstDate) {
      const change = Number(record.change || 0);
      const changeRate = Number(record.changeRate || 0);
      const isRise = changeRate > 0;
      const isFall = changeRate < 0;

      return (
        <div style={{ textAlign: "left", width: "100%" }}>
        <span
          style={{
            color: "#1890ff",
            cursor: "pointer",
            fontWeight: "bold",
            display: "inline-block",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleOpenDrawer(record, "area");
          }}
        >
          <span>{text}</span>
          {(change !== 0 || changeRate !== 0) && (
            <span
              style={{
                color: isRise ? "#EF4444" : "#01a031",
                marginLeft: "4px",fontWeight: "normal",
              }}
            >
              ({isRise ? <CaretUpOutlined /> : <CaretDownOutlined />}
              {change} &nbsp;&nbsp;
              <span style={{ fontWeight: "normal", marginLeft: "1px" }}>
                {formatVacancyRate(changeRate)})
              </span>
            </span>
          )}
        </span>
        </div>
      );
    }
    return text;
  },
});
    });

    // 添加统计列
    dynamicColumns.push(
      {
        title: "Last 30 Days",
        dataIndex: "last30DaysAvg",
        key: "last30DaysAvg",
        width: 120,
        render: (text) => {
          if (text === "-" || text === undefined || text === null) return "-";
          return text;
        },
      },
      {
        title: "Last 90 Days",
        dataIndex: "last90DaysAvg",
        key: "last90DaysAvg",
        width: 120,
        render: (text) => {
          if (text === "-" || text === undefined || text === null) return "-";
          return text;
        },
      },
      {
        title: "Last 12 Months",
        dataIndex: "last12MonthsAvg",
        key: "last12MonthsAvg",
        width: 120,
        render: (text) => {
          if (text === "-" || text === undefined || text === null) return "-";
          return text;
        },
      },
    );

    // 构建数据行
    const tableData = [];
    data.forEach((item, index) => {
      const row = {
        key: index + 1,
        area: item.name || "-",
        totalUnits: item.totalUnits || 0,
        vacancyRate: item.vacancyRate ?? 0,
        last30DaysAvg: item.last30DaysAvgVacantDays ?? 0,
        last90DaysAvg: item.last90DaysAvgVacantDays ?? 0,
        last12MonthsAvg: item.last12MonthsAvgVacantDays ?? 0,
        id: item.id,
        name: item.name,
        change: item.change,      
        changeRate: item.changeRate, 
      };

      // 填充每个日期的数据
      orderedKeys.forEach((dateKey) => {
        if (item.history && item.history[dateKey] !== undefined) {
          row[dateKey] = item.history[dateKey];
        } else {
          row[dateKey] = 0;
        }
      });

      tableData.push(row);
    });

    setColumns(dynamicColumns);
    setFilteredData(tableData);
  };

  return (
    <div className="dashboard-request-table">
      <CustomTable
        tableLoading={tableLoading}
        columns={columns}
        tableList={filteredData}
        tableScrollX={undefined}
        tableScrollYAll={780}
        rowKey="key"
        pagination={false}
        size="small"
      />
      <UnitDetailDrawer
        visible={drawerVisible}
        onClose={handleCloseDrawer}
        drawerType={drawerType}
        record={selectedRecord}
      />
      <PropDetailDrawer
        visible={drawerPropVisible}
        onClose={handleClosePropDrawer}
        drawerType={drawerType}
        record={selectedRecord}
      />
    </div>
  );
});

export default AreaIndex;
